<script lang="ts" setup>
import { PropType } from 'vue'

import { ScoredTeam } from '@/store/public/leagues.types'
import { formatFloat, formatValue } from '@/utils/format'

defineProps({
  team: {
    type: Object as PropType<ScoredTeam>,
    required: true,
  },
})
</script>

<template>
  <div class="table-container" style="width: 100%">
    <h2>{{ team?.name }}</h2>
    <table class="table">
      <thead>
        <tr>
          <th class="fit-content"></th>
          <th>{{ $t('leagues.labels.bowler') }}</th>
          <th class="align-center">{{ $t('bowler-scores.score') }}</th>
          <th class="align-center">{{ $t('leagues.labels.bonus') }}</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(row, i) in team?.bowlers" :key="`rundown-row-${i}`">
          <td>{{ i + 1 }}.</td>
          <td>{{ formatValue(row.full_name) }}</td>
          <td class="align-center">{{ formatFloat(row.score, 0) }}</td>
          <td class="align-center">{{ formatFloat(row.personal_bonus, 0) }}</td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td class="align-center">{{ formatFloat(team.team_score, 0) }}</td>
          <td class="align-center">{{ formatFloat(team.team_bonus, 0) }}</td>
        </tr>
        <tr>
          <td></td>
          <td class="align-right">
            <b>{{ $t('leagues.labels.points') }}</b>
          </td>
          <td class="align-center">
            <b>{{ formatFloat(team.team_points, 0) }}</b>
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss" scoped>
h2 {
  text-align: center;
}
</style>
